import CONSTANTS from '../constants'

// uses regex to check the password strength
const validatePassword = (pw) => {
  return CONSTANTS.PASSWORD_REGEX.test(pw)
}

export default validatePassword
